import React from 'react'
import { Pressable, StyleSheet, View, ViewProps } from 'react-native'

import { Href, Link } from 'zens-router'

import { Color, Spacing } from '../../style'
import { BrandingIdentity } from '../branding'
import { Hyperlink } from '../button'
import { MenuItemData, Menu } from '../menu'

const styles = StyleSheet.create({
  container: {
    width: 280,
  },
  unfolded: {
    width: 90,
  },
  top: {
    alignItems: 'center',
    paddingTop: Spacing.L,
    paddingBottom: 100,
  },
  topUnfolded: {
    paddingTop: Spacing.S,
    paddingBottom: 120,
  },
  button: {
    position: 'absolute',
    top: Spacing.S,
    right: Spacing.S,
  },
  buttonUnfolded: {
    marginBottom: Spacing.XS,
  },
  buttonText: {
    color: Color.calmGrey,
  },
})

export interface Props extends ViewProps {
  menu?: MenuItemData[]
  brandingIdentityHref?: Href
  onUnfold?: (value: boolean) => void
  unfolded?: boolean
}
const Side = (props: Props) => {
  const { menu, style, brandingIdentityHref, onUnfold, unfolded, ...otherProps } = props
  const containerStyle = [styles.container, unfolded && styles.unfolded, style]

  const toggleUnfolded = () => {
    onUnfold?.(!unfolded)
  }

  const brandingIdentity = <BrandingIdentity size={unfolded ? 'S' : 'M'} />

  return (
    <View style={containerStyle} {...otherProps}>
      <View style={[styles.top, unfolded && styles.topUnfolded]}>
        <Hyperlink
          right={unfolded ? 'menu' : 'left'}
          iconSize={unfolded ? 20 : 16}
          style={unfolded ? styles.buttonUnfolded : styles.button}
          textStyle={!unfolded && styles.buttonText}
          onPress={toggleUnfolded}
          testID="Side.Unfold"
        />
        {brandingIdentityHref ? (
          <Link href={brandingIdentityHref} asChild>
            <Pressable>{() => brandingIdentity}</Pressable>
          </Link>
        ) : (
          brandingIdentity
        )}
      </View>
      {menu && <Menu data={menu} unfolded={unfolded} />}
    </View>
  )
}

export default Side
